<!--P014、P015、P016、P017、P018、P019、P020、P022、P023、P025、P065-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'DistributionCenter'})">配送中心维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">配送中心详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">配送中心编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">配送中心名称</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.address" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_468 ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{DISTRIBUTION_CENTER_STATUS[search.isStop]}}</div>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue cs_margin_top_sm" style="margin-left: 182px;"
              type="button">保存
      </button>
    </div>

    <!--接入管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">接入管理</div>
    </div>
    <div class="cs_margin_top ui_switch">
      <button @click="showShop" :class="[linkManage==='SHOP'?'ui_switch_selected':'']"
              type="button">门店接入
      </button>
      <button @click="showSupplier" :class="[linkManage==='SUPPLIER'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">供应商接入
      </button>
      <button @click="showKitchen" :class="[linkManage==='KITCHEN'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">中央厨房接入
      </button>
    </div>
    <div class="div_search_result cs_padding_top_lg">
      <!--门店表格-->
      <template v-if="linkManage==='SHOP'">
        <div class="div_operation_table">
          <button @click="btnAddShop" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteShop" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="320px">门店编号</th>
              <th width="480px">门店名称</th>
              <th width="241px">门店启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in shopList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrShop(item)">
              <td>{{index+1}}</td>
              <td>{{item.shopNum}}</td>
              <td>{{item.shopName}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-shopList.length)">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--供应商表格-->
      <template v-if="linkManage==='SUPPLIER'">
        <div class="div_operation_table">
          <button @click="btnAddSupplier" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteSupplier" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="320px">供应商编号</th>
              <th width="480px">供应商名称</th>
              <th width="241px">供应商启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in supplierList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrSupplier(item)">
              <td>{{index+1}}</td>
              <td>{{item.supplierNum}}</td>
              <td>{{item.supplierName}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-supplierList.length)">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--中央厨房表格-->
      <template v-if="linkManage==='KITCHEN'">
        <div class="div_operation_table cs_align_center" style="height: 250px;">
          <div class="cs_title_primary cs_text_default type_info_search">接入中央厨房</div>
          <web-select :options="kitchenList"
                      @option-key="updateKitchen"
                      v-model="kitchenName"
                      class="cs_input cs_radius_lg edtxt_info_search" style="width: 280px;"></web-select>
        </div>
      </template>
      <!--门店、供应商分页-->
      <div v-show="linkManage==='SHOP'|| linkManage==='SUPPLIER'" class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="pageLink(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="pageLink(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jumpLink()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>

    <!--货品管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">货品管理</div>
    </div>
    <div class="cs_margin_top ui_switch">
      <button @click="showProduce" :class="[materialManage==='PRODUCE'?'ui_switch_selected':'']"
              type="button">产成品管理
      </button>
      <button @click="showPurchase" :class="[materialManage==='PURCHASE'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">采购货品管理
      </button>
      <button @click="showRequire" :class="[materialManage==='REQUIRE'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">要货货品管理
      </button>
      <button @click="showAllot" :class="[materialManage==='ALLOT'?'ui_switch_selected':'']"
              class="cs_margin_left_sm" type="button">调拨货品管理
      </button>
    </div>
    <!--产成品查询-->
    <div v-if="materialManage==='PRODUCE'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">货品</div>
      <input v-model="searchProduce.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquireProduce(1)">查询</button>
    </div>
    <!--采购查询-->
    <div v-if="materialManage==='PURCHASE'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">默认供应商</div>
      <search-select :options="searchPurchase.supplierSearchItems"
                     @option-key="updateSupplierNamePurchase"
                     v-model="searchPurchase.supplierName"
                     :search-fn="acquireSupplierItemPurchase"
                     class="cs_input cs_radius_lg edtxt_info_search width_280"></search-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品</div>
      <input v-model="searchPurchase.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquirePurchase(1)">查询</button>
    </div>
    <!--要货查询-->
    <div v-if="materialManage==='REQUIRE'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">要货门店</div>
      <search-select :options="searchRequire.shopSearchItems"
                     @option-key="updateShopNameRequire"
                     v-model="searchRequire.shopName"
                     :search-fn="acquireShopItemRequire"
                     class="cs_input cs_radius_lg edtxt_info_search width_280"></search-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品</div>
      <input v-model="searchRequire.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquireRequire(1)">查询</button>
    </div>
    <!--调拨查询-->
    <div v-if="materialManage==='ALLOT'" class="div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">货品</div>
      <input v-model="searchAllot.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="acquireAllot(1)">查询</button>
    </div>
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <!--产成品表格-->
      <template v-if="materialManage==='PRODUCE'">
        <div class="div_operation_table">
          <button @click="btnAddProduce" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteProduce" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="151px">货品编号</th>
              <th width="280px">货品名称</th>
              <th width="100px">规格</th>
              <th width="174px">库存单位</th>
              <th width="174px">成本单价</th>
              <th width="160px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in produceList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrProduce(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-produceList.length)">
              <td v-for="j in 7"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--采购表格-->
      <template v-if="materialManage==='PURCHASE'">
        <div class="div_operation_table">
          <button @click="btnAddPurchase" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnModifyPurchase" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">修改
          </button>
          <button @click="btnDeletePurchase" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="120px">货品编号</th>
              <th width="250px">货品名称</th>
              <th width="100px">规格</th>
              <th width="96px">采购单位</th>
              <th width="210px">默认供应商</th>
              <th width="132px">采购单价</th>
              <th width="130px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in purchaseList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrPurchase(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.sourceName}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-purchaseList.length)">
              <td v-for="j in 8"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--要货表格-->
      <template v-if="materialManage==='REQUIRE'">
        <div class="div_operation_table">
          <button @click="btnAddRequire" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteRequire" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="120px">货品编号</th>
              <th width="250px">货品名称</th>
              <th width="100px">规格</th>
              <th width="96px">库存单位</th>
              <th width="210px">要货门店</th>
              <th width="132px">配送单价</th>
              <th width="130px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in requireList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrRequire(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.shopName}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-requireList.length)">
              <td v-for="j in 8"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--调拨表格-->
      <template v-if="materialManage==='ALLOT'">
        <div class="div_operation_table">
          <button @click="btnAddAllot" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                  type="button">添加
          </button>
          <button @click="btnDeleteAllot" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                  type="button">删除
          </button>
        </div>
        <div class="cs_margin_top div_table">
          <table class="cs_table cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="40px">序号</th>
              <th width="151px">货品编号</th>
              <th width="280px">货品名称</th>
              <th width="100px">规格</th>
              <th width="174px">库存单位</th>
              <th width="174px">配送单价</th>
              <th width="160px">货品启用状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in allotList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrAllot(item)">
              <td>{{index+1}}</td>
              <td>{{item.materialNum}}</td>
              <td>{{item.materialName}}</td>
              <td>{{item.materialSpecs}}</td>
              <td>{{item.unit}}</td>
              <td>{{item.unitPrice}}</td>
              <td>{{SHOP_STATUS[item.isStop]}}</td>
            </tr>
            <tr v-for="(item,index) in (PAGE_SIZE-allotList.length)">
              <td v-for="j in 7"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <!--货品分页-->
      <div class="cs_text_sm cs_text_primary cs_margin_top_xs txt_hint_table">货品数量：{{totalItems}}</div>
      <div class="div_operation_table cs_align_right">
        <button v-show="materialManage==='PRODUCE'" @click="btnExportProduce" class="ui_btn_export" style="width:116px;position: absolute;top:16px;left:0"
                type="button">成本价导出
        </button>
        <button v-show="materialManage==='PURCHASE'" @click="btnExportPurchase" class="ui_btn_export" style="width:116px;position: absolute;top:16px;left:0"
                type="button">采购价导出
        </button>
        <!--上一页-->
        <button v-show="searchMaterial.pagination>1" @click="pageMaterial(searchMaterial.pagination < 2?1:searchMaterial.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="searchMaterial.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{searchMaterial.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{searchMaterial.totalPage}}</div>
        <!--下一页-->
        <button v-show="searchMaterial.pagination!==searchMaterial.totalPage" @click="pageMaterial(searchMaterial.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="searchMaterial.pagination===searchMaterial.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jumpMaterial()" class="type_page_jump">跳转至</div>
        <input v-model="searchMaterial.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="searchMaterial.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--接入门店弹窗，默认隐藏-->
    <div v-if="isDialogShopShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:372px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">接入门店</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">门店</div>
          <search-select :options="dialogShop.shopSearchItems"
                         @option-key="updateShopName"
                         v-model="dialogShop.shopName"
                         :search-fn="acquireShopItem"
                         class="cs_input cs_radius_lg edtxt_info_search width_246"></search-select>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{dialogShop.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogLink">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialogShop">确定</button>
        </div>
      </div>
    </div>
    <!--接入供应商弹窗，默认隐藏-->
    <div v-if="isDialogSupplierShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:386px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">接入供应商</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">供应商</div>
          <search-select :options="dialogSupplier.supplierSearchItems"
                         @option-key="updateSupplierName"
                         v-model="dialogSupplier.supplierName"
                         :search-fn="acquireSupplierItem"
                         class="cs_input cs_radius_lg edtxt_info_search width_246"></search-select>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{dialogSupplier.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogLink">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialogSupplier">确定</button>
        </div>
      </div>
    </div>
    <!--添加产成品弹窗，默认隐藏-->
    <div v-if="isDialogProduceShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:416px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加产成品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogProduce.materialSearchItems"
                         @option-key="updateMaterialNameProduce"
                         v-model="dialogProduce.materialName"
                         :search-fn="acquireMaterialItemProduce"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_44">{{dialogProduce.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">库存单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogProduce.dcStockUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">成本单价</div>
          <input v-model="priceProduce" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceProduce=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogProduce.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmProduceDialog">确定</button>
        </div>
      </div>
    </div>
    <!--添加采购弹窗，默认隐藏-->
    <div v-if="isDialogPurchaseShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加采购货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogPurchase.materialSearchItems"
                         @option-key="updateMaterialNamePurchase"
                         v-model="dialogPurchase.materialName"
                         :search-fn="acquireMaterialItemPurchase"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogPurchase.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">默认供应商</div>
          <web-select :options="dialogPurchase.supplierList"
                      @option-key="updateSupplierPurchase"
                      v-model="dialogPurchase.supplierName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.unitPrice}}</div>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogPurchase.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmPurchaseDialog">确定</button>
        </div>
      </div>
    </div>
    <!--修改采购弹窗，默认隐藏-->
    <div v-if="isDialogModifyPurchaseShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">修改采购货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogModifyPurchase.materialName}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogModifyPurchase.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogModifyPurchase.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">默认供应商</div>
          <web-select :options="dialogModifyPurchase.supplierList"
                      @option-key="updateSupplierPurchaseModify"
                      v-model="dialogModifyPurchase.supplierName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogModifyPurchase.unitPrice}}</div>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogModifyPurchase.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmPurchaseDialogModify">确定</button>
        </div>
      </div>
    </div>
    <!--添加要货货品弹窗，默认隐藏-->
    <div v-if="isDialogRequireShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加要货货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogRequire.materialSearchItems"
                         @option-key="updateMaterialNameRequire"
                         v-model="dialogRequire.materialName"
                         :search-fn="acquireMaterialItemRequire"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_44">{{dialogRequire.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">库存单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogRequire.stockUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">要货门店</div>
          <div class="cs_radius_lg txt_info_search width_108">{{shopRequireSelectedList.length}}</div>
          <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">家</div>
          <button @click="btnShopRequire" type="button" class="cs_btn ui_btn_blue cs_margin_left">编辑</button>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">配送单价</div>
          <input v-model="priceRequire" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceRequire=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogRequire.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmRequireDialog">确定</button>
        </div>
      </div>
    </div>
    <!--编辑要货门店弹窗，默认显示-->
    <div v-if="isDialogShopRequireShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑要货门店</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none table_confirm" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">门店编号</th>
              <th width="100%">门店名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in shopRequireList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrRequireDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.shopNum}}</td>
              <td width="100%">{{item.shopName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>shopRequireList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-shopRequireList.length)">
                <td width="44px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogShopRequire">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmShopRequireDialog">确定</button>
        </div>
      </div>
    </div>
    <!--添加调拨货品弹窗，默认隐藏-->
    <div v-if="isDialogAllotShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:416px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加调拨货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogAllot.materialSearchItems"
                         @option-key="updateMaterialNameAllot"
                         v-model="dialogAllot.materialName"
                         :search-fn="acquireMaterialItemAllot"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_44">{{dialogAllot.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">库存单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogAllot.stockUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">配送单价</div>
          <input v-model="priceAllot" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceAllot=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogAllot.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmAllotDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {Page, PAGE_SIZE,DISTRIBUTION_CENTER_STATUS,SHOP_STATUS} from "../../assets/utils/constants"
  export default {
    name: "DistributionCenterDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        linkManage: "SHOP",
        search: {
          num: "",
          name: "",
          contactName: "",
          mobileNo: "",
          address: "",
          isStop: "",
          pageJump: "",
          totalPage: "",
          pagination: 1
        },
        shopList: [],
        selectedIdShop: "",
        isDialogShopShow: false,
        dialogShop: {
          shopId: "",
          shopName: "",
          shopSearchItems: [],
          hintDialog: "",
        },
        supplierList: [],
        selectedIdSupplier: "",
        isDialogSupplierShow: false,
        dialogSupplier: {
          supplierId: "",
          supplierName: "",
          supplierSearchItems: [],
          hintDialog: "",
        },
        kitchenList: [],
        kitchenId: "",
        kitchenName: "",
        materialManage: "PRODUCE",
        searchMaterial: {
          pageJump: "",
          totalPage: "",
          pagination: 1
        },
        searchProduce:{
          name: "",
        },
        produceList: [],
        selectedIdProduce: "",
        isDialogProduceShow: false,
        dialogProduce: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          dcStockUnit: "",
          materialSpecs:""
        },
        priceProduce: "",
        searchPurchase: {
          name: "",
          supplierId: 0,
          supplierName: "",
          supplierSearchItems: [],
        },
        purchaseList: [],
        selectedIdPurchase: "",
        isDialogPurchaseShow: false,
        dialogPurchase: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          materialSpecs:"",
          hintDialog: "",
        },
        isDialogModifyPurchaseShow: false,
        dialogModifyPurchase: {
          materialId: "",
          materialName: "",
          purchaseUnit: "",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        },
        searchRequire: {
          name: "",
          shopId: 0,
          shopName: "",
          shopSearchItems: [],
        },
        requireList: [],
        selectedIdRequire: "",
        selectedShopIdRequire: "",
        isDialogRequireShow: false,
        dialogRequire: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        },
        priceRequire: "",
        isDialogShopRequireShow: false,
        shopRequireList: [],
        shopRequireSelectedList: [],

        searchAllot: {
          name: "",
        },
        allotList: [],
        selectedIdAllot: "",
        isDialogAllotShow: false,
        dialogAllot: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        },
        priceAllot: "",
        totalItems:"",
        PAGE_SIZE: PAGE_SIZE,
        DISTRIBUTION_CENTER_STATUS: DISTRIBUTION_CENTER_STATUS,
        SHOP_STATUS: SHOP_STATUS
      }
    },
    created: function () {
      this.showDetail();
      if(this.linkManage === "SHOP"){
        this.showShop();
      }else if(this.linkManage === "SUPPLIER"){
        this.showSupplier();
      }else {
        this.showKitchen();
      }
      if(this.materialManage === "PRODUCE"){
        this.showProduce();
      }else if(this.materialManage === "PURCHASE"){
        this.showPurchase();
      }else if(this.materialManage === "REQUIRE"){
        this.showRequire();
      }else {
        this.showAllot();
      }
      //下拉框
      this.showKitchenList();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.distributionCenter.acquire.bind(this)(this.$route.query.id,(data) => {
          this.search.num = data.data.dcNum;
          this.search.name = data.data.dcName;
          this.search.contactName = data.data.contactName;
          this.search.mobileNo = data.data.mobileNo;
          this.search.address = data.data.dcAddress;
          this.search.isStop = data.data.isStop;
        }, (data) => {
        }, true)
      },
      btnSave(){
        if(this.isEmpty(this.search.name)){
          this.$toast("请输入配送中心名称");
          return;
        }
        this.$ajax.distributionCenter.modify.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
        }, (data) => {
        }, true)
      },
      // 门店
      showShop() {
        this.linkManage = "SHOP";
        this.search.pageJump = "";
        this.acquireShop(1);
      },
      showSupplier() {
        this.linkManage = "SUPPLIER";
          this.search.pageJump = "";
        this.acquireSupplier(1);
      },
      showKitchen() {
        this.linkManage = "KITCHEN";
        this.acquireKitchen();
      },
      pageLink(pagination){
        if(this.linkManage === "SHOP"){
          this.acquireShop(pagination);
          return;
        }
        if(this.linkManage === "SUPPLIER"){
          this.acquireSupplier(pagination);
        }
      },
      jumpLink() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            if(this.linkManage === "SHOP"){
              this.acquireShop(this.search.totalPage);
            }else {
              this.acquireSupplier(this.search.totalPage);
            }
          }else {
            if(this.linkManage === "SHOP"){
              this.acquireShop(this.search.pageJump);
            }else {
              this.acquireSupplier(this.search.pageJump);
            }
          }
        }
      },
      acquireShop(pagination){
        this.$ajax.distributionCenter.listShop.bind(this)(this.$route.query.id, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.shopList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrShop(item){
        let selectedStatus = item.isSelected;
        this.shopList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdShop = item.id;
        }else {
          this.selectedIdShop = "";
        }
      },
      btnDeleteShop(){
        if(this.isEmpty(this.selectedIdShop)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteShop.bind(this)(this.$route.query.id,this.selectedIdShop, (data) => {
          this.$toast("删除成功");
          this.selectedIdShop = "";
          this.acquireShop(this.search.pagination);
        }, (data) => {
        }, true)
      },
      btnAddShop(){
        this.isDialogShopShow = true;
      },
      btnConfirmDialogShop(){
        if (this.isEmpty(this.dialogShop.shopId)) {
          this.dialogShop.hintDialog= "请选择门店";
          return
        }
        this.$ajax.distributionCenter.addShop.bind(this)(this.$route.query.id,this.dialogShop.shopId, (data) => {
          this.$toast("添加成功");
          this.acquireShop(this.search.pagination);
          this.closeDialogLink();
        }, (data) => {
        }, true,this.showErrorMsgShop())
      },
      closeDialogLink(){
        this.isDialogShopShow = false;
        this.dialogShop = {
          shopId: "",
          shopName: "",
          shopSearchItems: [],
          hintDialog: "",
        };
        this.isDialogSupplierShow = false;
        this.dialogSupplier = {
          supplierId: "",
          supplierName: "",
          supplierSearchItems: [],
          hintDialog: "",
        };
      },
      acquireShopItem(search) {
        this.$ajax.common.searchShop.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].shopNum + "  " + data.data[i].shopName,
            })
          }
          this.dialogShop.shopSearchItems = array;
        }, this.failDefault, false);
      },
      updateShopName(key) {
        this.dialogShop.shopId = key;
      },
      showErrorMsgShop: function (msg) {
        this.dialogShop.hintDialog = msg;
      },
      // 供应商
      acquireSupplier(pagination){
        this.$ajax.distributionCenter.listSupplier.bind(this)(this.$route.query.id, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.supplierList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrSupplier(item){
        let selectedStatus = item.isSelected;
        this.supplierList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdSupplier = item.id;
        }else {
          this.selectedIdSupplier = "";
        }
      },
      btnDeleteSupplier(){
        if(this.isEmpty(this.selectedIdSupplier)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteSupplier.bind(this)(this.$route.query.id,this.selectedIdSupplier, (data) => {
          this.$toast("删除成功");
          this.selectedIdSupplier = "";
          this.acquireSupplier(this.search.pagination);
        }, (data) => {
        }, true)
      },
      btnAddSupplier(){
        this.isDialogSupplierShow = true;
      },
      btnConfirmDialogSupplier(){
        if (this.isEmpty(this.dialogSupplier.supplierId)) {
          this.dialogSupplier.hintDialog= "请选择供应商";
          return
        }
        this.$ajax.distributionCenter.addSupplier.bind(this)(this.$route.query.id,this.dialogSupplier.supplierId, (data) => {
          this.$toast("添加成功");
          this.acquireSupplier(this.search.pagination);
          this.closeDialogLink();
        }, (data) => {
        }, true,this.showErrorMsgSupplier())
      },
      acquireSupplierItem(search) {
        this.$ajax.common.searchSupplier.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum + "  " + data.data[i].supplierName,
            })
          }
          this.dialogSupplier.supplierSearchItems = array;
        }, this.failDefault, false);
      },
      updateSupplierName(key) {
        this.dialogSupplier.supplierId = key;
      },
      showErrorMsgSupplier: function (msg) {
        this.dialogSupplier.hintDialog = msg;
      },
      // 中央厨房
      acquireKitchen(){
        this.$ajax.distributionCenter.acquireKitchen.bind(this)(this.$route.query.id, (data) => {
          this.kitchenId = "";
          this.kitchenName = "";
          if(!this.isEmpty(data.data)){
            this.kitchenId = data.data.id;
            this.kitchenName = data.data.kitchenName;
          }
        }, (data) => {
        }, true)
      },
      showKitchenList(){
        this.$ajax.common.listKitchen.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].kitchenName,
            })
          }
          this.kitchenList = array;
        }, (data) => {
        }, true)
      },
      updateKitchen(key) {
        this.kitchenId = key;
        //提交修改中央厨房
        this.$ajax.distributionCenter.modifyKitchen.bind(this)(this.$route.query.id,key,(data) => {
          this.$toast("修改成功");
          this.acquireKitchen();
        }, (data) => {
        }, true)
      },

      // 产成品
      showProduce(){
        this.materialManage = "PRODUCE";
        this.searchMaterial.pageJump = "";
        this.acquireProduce(1);
      },
      acquireProduce(pagination){
        this.$ajax.distributionCenter.listProduceMaterial.bind(this)(this.$route.query.id, this.searchProduce.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.totalItems = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.produceList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrProduce(item){
        let selectedStatus = item.isSelected;
        this.produceList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdProduce = item.materialId;
        }else {
          this.selectedIdProduce = "";
        }
      },
      btnDeleteProduce(){
        if(this.isEmpty(this.selectedIdProduce)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteMaterial.bind(this)(this.$route.query.id,this.selectedIdProduce, (data) => {
          this.$toast("删除成功");
          this.selectedIdProduce = "";
          this.acquireProduce(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddProduce(){
        this.isDialogProduceShow = true;
      },
      btnConfirmProduceDialog(){
        if (this.isEmpty(this.dialogProduce.materialId)) {
          this.dialogProduce.hintDialog = "请选中一个货品";
          return
        }
        if (this.isEmpty(this.priceProduce)) {
          this.dialogProduce.hintDialog = "请输入成本单价";
          return
        }
        this.$ajax.distributionCenter.addProduceMaterial.bind(this)(this.$route.query.id,this.dialogProduce.materialId, this.priceProduce, (data) => {
          this.$toast("添加成功");
          this.acquireProduce(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgProduce)
      },
      acquireMaterialItemProduce(search) {
        this.$ajax.common.searchProduceMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              dcStockUnit: data.data[i].dcStockUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogProduce.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNameProduce(key) {
        this.dialogProduce.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogProduce.materialSearchItems.length;i++){
            if(this.dialogProduce.materialSearchItems[i].key === key){
              this.dialogProduce.dcStockUnit = this.dialogProduce.materialSearchItems[i].dcStockUnit;
              this.dialogProduce.materialSpecs = this.dialogProduce.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogProduce.hintDialog = "";
          this.dialogProduce.dcStockUnit = "";
          this.dialogProduce.materialSpecs = "";
          this.priceProduce = "";
        }
      },
      showErrorMsgProduce: function (msg) {
        this.dialogProduce.hintDialog = msg;
      },
      pageMaterial(pagination){
        if(this.materialManage === "PRODUCE"){
          this.acquireProduce(pagination);
          return;
        }
        if(this.materialManage === "PURCHASE"){
          this.acquirePurchase(pagination);
          return;
        }
        if(this.materialManage === "REQUIRE"){
          this.acquireRequire(pagination);
          return;
        }
        if(this.materialManage === "ALLOT"){
          this.acquireAllot(pagination);
        }
      },
      jumpMaterial() {
        if (!this.isEmpty(this.searchMaterial.pageJump)) {
          let searchPage = this.searchMaterial.pageJump>this.searchMaterial.totalPage?this.searchMaterial.totalPage:this.searchMaterial.pageJump;
          if(this.materialManage === "PRODUCE"){
            this.acquireProduce(searchPage);
            return;
          }
          if(this.materialManage === "PURCHASE"){
            this.acquirePurchase(searchPage);
            return;
          }
          if(this.materialManage === "REQUIRE"){
            this.acquireRequire(searchPage);
            return;
          }
          if(this.materialManage === "ALLOT"){
            this.acquireAllot(searchPage);
          }
        }
      },
      closeDialogMaterial(){
        this.isDialogProduceShow = false;
        this.dialogProduce = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          dcStockUnit: "",
          materialSpecs:""
        };
        this.priceProduce = "";
        this.isDialogPurchaseShow = false;
        this.dialogPurchase = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.isDialogModifyPurchaseShow= false;
        this.dialogModifyPurchase= {
          materialId: "",
          materialName: "",
          purchaseUnit: "",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.isDialogRequireShow= false;
        this.dialogRequire= {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        };
        this.priceRequire= "";
        this.isDialogShopRequireShow= false;
        this.shopRequireList= [];
        this.shopRequireSelectedList= [];
        this.isDialogAllotShow= false;
        this.dialogAllot= {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          stockUnit: "",
          materialSpecs:""
        };
        this.priceAllot= "";
      },
      btnExportProduce(){
        this.$ajax.distributionCenter.exportProduceMaterial.bind(this)(this.$route.query.id, this.searchProduce.name, (response) => {
          let fileName = "成本价-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      },
      // 采购
      showPurchase(){
        this.materialManage = "PURCHASE";
        this.searchMaterial.pageJump = "";
        this.acquirePurchase(1);
      },
      acquirePurchase(pagination){
        this.$ajax.distributionCenter.listPurchaseMaterial.bind(this)(this.$route.query.id,this.searchPurchase.supplierId, this.searchPurchase.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.totalItems = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.purchaseList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrPurchase(item){
        let selectedStatus = item.isSelected;
        this.purchaseList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdPurchase = item.materialId;
        }else {
          this.selectedIdPurchase = "";
        }
      },
      btnDeletePurchase(){
        if(this.isEmpty(this.selectedIdPurchase)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteMaterial.bind(this)(this.$route.query.id,this.selectedIdPurchase, (data) => {
          this.$toast("删除成功");
          this.selectedIdPurchase = "";
          this.acquirePurchase(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddPurchase(){
        this.isDialogPurchaseShow = true;
      },
      btnConfirmPurchaseDialog(){
        if (this.isEmpty(this.dialogPurchase.materialId)) {
          this.dialogPurchase.hintDialog = "请选择货品";
          return
        }
        if (this.isEmptySelect(this.dialogPurchase.supplierId)) {
          this.dialogPurchase.hintDialog = "请选择默认供应商";
          return
        }
        this.$ajax.distributionCenter.addPurchaseMaterial.bind(this)(this.$route.query.id,this.dialogPurchase.materialId,this.dialogPurchase.supplierId, (data) => {
          this.$toast("添加成功");
          this.acquirePurchase(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgPurchase)
      },
      acquireMaterialItemPurchase(search) {
        this.$ajax.common.searchMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              purchaseUnit: data.data[i].purchaseUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogPurchase.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNamePurchase(key) {
        this.dialogPurchase.materialId = key;
        if(!this.isEmpty(key)){
          this.acquireSupplierListPurchase(key);
          for(let i=0;i<this.dialogPurchase.materialSearchItems.length;i++){
            if(this.dialogPurchase.materialSearchItems[i].key === key){
              this.dialogPurchase.purchaseUnit = this.dialogPurchase.materialSearchItems[i].purchaseUnit;
              this.dialogPurchase.materialSpecs = this.dialogPurchase.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.purchaseUnit = "";
          this.dialogPurchase.materialSpecs = "";
          this.dialogPurchase.supplierList = [];
          this.dialogPurchase.supplierId = 0;
          this.dialogPurchase.supplierName = "";
          this.dialogPurchase.unitPrice = "";
        }
      },
      showErrorMsgPurchase: function (msg) {
        this.dialogPurchase.hintDialog = msg;
      },
      acquireSupplierItemPurchase(search) {
        this.$ajax.common.searchSupplier.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum + "  " + data.data[i].supplierName,
            })
          }
          this.searchPurchase.supplierSearchItems = array;
        }, this.failDefault, false);
      },
      updateSupplierNamePurchase(key) {
        if(!this.isEmpty(key)){
          this.searchPurchase.supplierId = key;
          return;
        }
        this.searchPurchase.supplierId = 0;
      },
      acquireSupplierListPurchase(materialId){
        this.$ajax.common.listSupplierByMaterial.bind(this)(materialId,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum +"  "+ data.data[i].supplierName,
              unitPrice: data.data[i].unitPrice,
            })
          }
          this.dialogPurchase.supplierList = array;
        }, (data) => {
        }, true)
      },
      updateSupplierPurchase(key) {
        this.dialogPurchase.supplierId = key;
        if(!this.isEmptySelect(key)){
          for(let i=0;i<this.dialogPurchase.supplierList.length;i++){
            if(this.dialogPurchase.supplierList[i].key === key){
              this.dialogPurchase.unitPrice = this.dialogPurchase.supplierList[i].unitPrice;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.unitPrice = "";
        }
      },
      btnModifyPurchase(){
        if(this.isEmpty(this.selectedIdPurchase)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.purchaseList.some((item) => {
          if(this.selectedIdPurchase === item.materialId){
            this.dialogModifyPurchase.materialId = item.materialId;
            this.dialogModifyPurchase.materialName= item.materialNum+ "  "+item.materialName;
            this.dialogModifyPurchase.purchaseUnit= item.unit;
            this.dialogModifyPurchase.supplierId= item.sourceId;
            this.dialogModifyPurchase.supplierName= item.sourceNum+"  "+item.sourceName;
            this.dialogModifyPurchase.unitPrice= item.unitPrice;
            this.dialogModifyPurchase.materialSpecs= item.materialSpecs;
            return true;
          }
        });
        this.acquireSupplierListPurchaseModify(this.selectedIdPurchase);
        this.isDialogModifyPurchaseShow = true;
      },
      btnConfirmPurchaseDialogModify(){
        if (this.isEmptySelect(this.dialogModifyPurchase.supplierId)) {
          this.dialogModifyPurchase.hintDialog = "请选择默认供应商";
          return
        }
        this.$ajax.distributionCenter.modifyPurchaseMaterial.bind(this)(this.$route.query.id,this.dialogModifyPurchase.materialId,this.dialogModifyPurchase.supplierId, (data) => {
          this.$toast("修改成功");
          this.acquirePurchase(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgPurchaseModify)
      },
      showErrorMsgPurchaseModify: function (msg) {
        this.dialogModifyPurchase.hintDialog = msg;
      },
      acquireSupplierListPurchaseModify(materialId){
        this.$ajax.common.listSupplierByMaterial.bind(this)(materialId,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum +"  "+ data.data[i].supplierName,
              unitPrice: data.data[i].unitPrice,
            })
          }
          this.dialogModifyPurchase.supplierList = array;
        }, (data) => {
        }, true)
      },
      updateSupplierPurchaseModify(key) {
        this.dialogModifyPurchase.supplierId = key;
        if(!this.isEmptySelect(key)){
          for(let i=0;i<this.dialogModifyPurchase.supplierList.length;i++){
            if(this.dialogModifyPurchase.supplierList[i].key === key){
              this.dialogModifyPurchase.unitPrice = this.dialogModifyPurchase.supplierList[i].unitPrice;
              return;
            }
          }
        }else {
          this.dialogModifyPurchase.hintDialog = "";
          this.dialogModifyPurchase.unitPrice = "";
        }
      },
      btnExportPurchase(){
        this.$ajax.distributionCenter.exportPurchaseMaterial.bind(this)(this.$route.query.id,this.searchPurchase.supplierId, this.searchPurchase.name, (response) => {
          let fileName = "采购价-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      },

      // 要货
      showRequire(){
        this.materialManage = "REQUIRE";
        this.searchMaterial.pageJump = "";
        this.acquireRequire(1);
      },
      acquireRequire(pagination){
        this.$ajax.distributionCenter.listRequireMaterial.bind(this)(this.$route.query.id,this.searchRequire.shopId, this.searchRequire.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.totalItems = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.requireList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrRequire(item){
        let selectedStatus = item.isSelected;
        this.requireList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdRequire = item.materialId;
          this.selectedShopIdRequire = item.shopId;
        }else {
          this.selectedIdRequire = "";
          this.selectedShopIdRequire = "";
        }
      },
      btnDeleteRequire(){
        if(this.isEmpty(this.selectedIdRequire)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteRequireMaterial.bind(this)(this.selectedShopIdRequire,this.selectedIdRequire, (data) => {
          this.$toast("删除成功");
          this.selectedIdRequire = "";
          this.selectedShopIdRequire = "";
          this.acquireRequire(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddRequire(){
        this.isDialogRequireShow = true;
      },
      btnConfirmRequireDialog(){
        if (this.isEmpty(this.dialogRequire.materialId)) {
          this.dialogRequire.hintDialog = "请选中一个货品";
          return
        }
        if(this.shopRequireSelectedList.length<1){
          this.dialogRequire.hintDialog = "请选择要货门店";
          return
        }
        if (this.isEmpty(this.priceRequire)) {
          this.dialogRequire.hintDialog = "请输入配送单价";
          return
        }
        let shopIds=this.shopRequireSelectedList[0];
        for (let i = 1; i < this.shopRequireSelectedList.length; i++) {
          shopIds = shopIds + "," + this.shopRequireSelectedList[i];
        }
        this.$ajax.distributionCenter.addRequireMaterial.bind(this)(this.$route.query.id,this.dialogRequire.materialId, shopIds, this.priceRequire, (data) => {
          this.$toast("添加成功");
          this.acquireRequire(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgRequire)
      },
      acquireMaterialItemRequire(search) {
        this.$ajax.distributionCenter.searchMaterial.bind(this)(this.$route.query.id,search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].materialId,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              stockUnit: data.data[i].stockUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogRequire.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNameRequire(key) {
        this.dialogRequire.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogRequire.materialSearchItems.length;i++){
            if(this.dialogRequire.materialSearchItems[i].key === key){
              this.dialogRequire.stockUnit = this.dialogRequire.materialSearchItems[i].stockUnit;
              this.dialogRequire.materialSpecs = this.dialogRequire.materialSearchItems[i].materialSpecs;
              return;
            }
          }
          //判断货品、门店是否为空，不为空时查询配送单价
          this.showPriceRequire()
        }else {
          this.dialogRequire.hintDialog = "";
          this.dialogRequire.stockUnit = "";
          this.dialogRequire.materialName = "";
          this.dialogRequire.materialSpecs = "";
          this.priceRequire = "";
        }
      },
      showPriceRequire(){
        if(!this.isEmpty(this.dialogRequire.materialId) && this.shopRequireSelectedList.length>0){
          this.$ajax.distributionCenter.acquireDefaultPrice.bind(this)(this.$route.query.id,this.dialogRequire.materialId, this.shopRequireSelectedList[0], (data) => {
            this.priceRequire = data.data;
          })
        }
      },
      showErrorMsgRequire: function (msg) {
        this.dialogRequire.hintDialog = msg;
      },
      acquireShopItemRequire(search) {
        this.$ajax.common.searchShop.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].shopNum + "  " + data.data[i].shopName,
            })
          }
          this.searchRequire.shopSearchItems = array;
        }, this.failDefault, false);
      },
      updateShopNameRequire(key) {
        if(!this.isEmpty(key)){
          this.searchRequire.shopId = key;
          return;
        }
        this.searchRequire.shopId = 0;
      },
      btnShopRequire(){
        this.shopRequireSelectedList = [];
        //显示门店列表
        this.$ajax.distributionCenter.listShop.bind(this)(this.$route.query.id, new Page(100, 1), (data) => {
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.shopRequireList = list;
        }, (data) => {
        }, true);
        this.isDialogShopRequireShow = true;
      },
      btnSelectTableTrRequireDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.shopRequireSelectedList.push(item.id);
        }else {
          for(let i=0;i<this.shopRequireSelectedList.length;i++){
            if(item.id===this.shopRequireSelectedList[i]){
              this.shopRequireSelectedList.splice(i, 1);
              return
            }
          }
        }
      },
      closeDialogShopRequire(){
        this.shopRequireList = [];
        this.shopRequireSelectedList = [];
        this.isDialogShopRequireShow = false;
      },
      btnConfirmShopRequireDialog(){
        if(this.shopRequireSelectedList.length<1){
          this.$toast("请选择要货门店");
          return
        }
        this.showPriceRequire();
        this.shopRequireList = [];
        this.isDialogShopRequireShow = false;
      },

      // 调拨
      showAllot(){
        this.materialManage = "ALLOT";
        this.searchMaterial.pageJump = "";
        this.acquireAllot(1);
      },
      acquireAllot(pagination){
        this.$ajax.distributionCenter.listAllotMaterial.bind(this)(this.$route.query.id, this.searchAllot.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.searchMaterial.totalPage = data.data.totalPage;
          this.searchMaterial.pagination = data.data.pagination;
          this.totalItems = data.data.totalItem;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.allotList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTrAllot(item){
        let selectedStatus = item.isSelected;
        this.allotList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdAllot = item.materialId;
        }else {
          this.selectedIdAllot = "";
        }
      },
      btnDeleteAllot(){
        if(this.isEmpty(this.selectedIdAllot)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.distributionCenter.deleteAllotMaterial.bind(this)(this.$route.query.id,this.selectedIdAllot, (data) => {
          this.$toast("删除成功");
          this.selectedIdAllot = "";
          this.acquireAllot(this.searchMaterial.pagination);
        }, (data) => {
        }, true)
      },
      btnAddAllot(){
        this.isDialogAllotShow = true;
      },
      btnConfirmAllotDialog(){
        if (this.isEmpty(this.dialogAllot.materialId)) {
          this.dialogAllot.hintDialog = "请选中一个货品";
          return
        }
        if (this.isEmpty(this.priceAllot)) {
          this.dialogAllot.hintDialog = "请输入配送单价";
          return
        }
        this.$ajax.distributionCenter.addAllotMaterial.bind(this)(this.$route.query.id,this.dialogAllot.materialId, this.priceAllot, (data) => {
          this.$toast("添加成功");
          this.acquireAllot(this.searchMaterial.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgAllot)
      },
      acquireMaterialItemAllot(search) {
        this.$ajax.distributionCenter.searchMaterial.bind(this)(this.$route.query.id, search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].materialId,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              stockUnit: data.data[i].stockUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogAllot.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNameAllot(key) {
        this.dialogAllot.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogAllot.materialSearchItems.length;i++){
            if(this.dialogAllot.materialSearchItems[i].key === key){
              this.dialogAllot.stockUnit = this.dialogAllot.materialSearchItems[i].stockUnit;
              this.dialogAllot.materialSpecs = this.dialogAllot.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogAllot.hintDialog = "";
          this.dialogAllot.stockUnit = "";
          this.dialogAllot.materialName = "";
          this.dialogAllot.materialSpecs = "";
          this.priceAllot = "";
        }
      },
      showErrorMsgAllot: function (msg) {
        this.dialogAllot.hintDialog = msg;
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_468{
    width: 468px;
  }
  .width_246{width: 246px;}
  .width_108{width: 108px;}
  .width_280{width: 280px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .margin_top_12{margin-top: 12px;}
  .margin_left_18{margin-left: 18px;}
  .table_confirm tbody{max-height: 411px;}
  .txt_hint_table{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/distribution-center/DistributionCenterDetail.vue